import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

export const fetchOrders = createAsyncThunk("orders/fetchOrders", async () => {
  const response = await apiCustom.get("order-show");
  return response.data?.data?.order;
});
export const createOrders = createAsyncThunk(
  "orders/createOrders",
  async (newPost, { rejectWithValue }) => {
    try {
      const response = await apiCustom.post("/order-create", newPost, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const updateOrders = createAsyncThunk(
  "orders/updateOrders",
  async ({ id, newPost }, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(`/order-update/${id}`, newPost);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
export const getOrdersById = createAsyncThunk(
  "orders/getOrdersById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await apiCustom.get(`/order-show-id/${id}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
export const getOrdersByCustomerId = createAsyncThunk(
  "orders/getOrdersByCustomerId",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.get(`/order-show-history/${id}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
export const getOrdersByCompanyId = createAsyncThunk(
  "orders/getOrdersByCompanyId",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.get(`/order-show-current/${id}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

const ordersSlice = createSlice({
  name: "orders",
  initialState: {
    orders: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.orders = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(createOrders.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(getOrdersById.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(updateOrders.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(getOrdersByCustomerId.fulfilled, (state, action) => {
        state.status = "idle";
        state.orders = action.payload;
      })
      .addCase(getOrdersByCompanyId.fulfilled, (state, action) => {
        state.status = "idle";
        state.orders = action.payload;
      });
  },
});

export default ordersSlice.reducer;
